import { CLOSE_MODAL } from './modal-actions';

export const createModalClosedMiddleware =
  ({ createShowMessage, modalResolverMapByType }: any) =>
  (store: any) => {
    const showMessage = createShowMessage(store);

    return (next: any) => (action: any) => {
      if (action.type === CLOSE_MODAL) {
        const {
          payload: { type, resolve },
        } = action;

        const resolver = modalResolverMapByType[type];
        if (resolver && !(resolve === false || resolve === undefined)) {
          store.dispatch(
            resolver(resolve, {
              showMessage,
            }),
          );
        }
      }

      next(action);
    };
  };
